import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOrganizationsOptionsAction} from '../action';

function* execute({payload}: GetManagementOrganizationsOptionsAction): SagaIterator {
    const response = yield* call(Api.searchOrganizationsForPrincipal, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOrganizationsOptions(response.data.map(o => ({
            value: o.id,
            label: `${o.code}${o.name ? ` - ${o.name}` : ''}`,
        }))));
    } else {
        yield putAll(showBeError(response, t('userDetail')('organizationsLoading')));
    }
}
/** Runs the admin saga that loads organization options for the management form. */
export function* getManagementOrganizationsOptionsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ORGANIZATIONS_OPTIONS', execute);
}
